export default (props, vars) => `Thanks, ${props?.['user'].name}!`;
